// extracted by mini-css-extract-plugin
export default {"input":"Input_input__76NDL","readOnly":"Input_readOnly__9KjK2"};